// extracted by mini-css-extract-plugin
export default {"button":"loading_button__yhgzr","rotating":"loading_rotating__vBv-7"};